module.exports = __webpack_public_path__ + "static/media/arrow-right.37523613.svg";